import * as utilsTypes from './utilsTypes';
import { getUtilsState } from './utilsReselect';

export const toggleDrawer = anchor => {
  return (dispatch, getState) => {
    const state = getUtilsState(getState());

    dispatch({
      type: utilsTypes.TOGGLE_DRAWER,
      payload: !state.drawerState[anchor].open,
      anchor: anchor,
    });
  };
};

// export const toggleDrawerRight = () => {
//   return (dispatch, getState) => {
//     const state = getUtilsState(getState());

//     dispatch({
//       type: utilsTypes.TOGGLE_DRAWER_RIGHT,
//       payload: !state.rightDrawerState.open,
//     });
//   };
// };

export const showNotification = (message, options = {}) => ({
  type: utilsTypes.SHOW_NOTIFICATION,
  notification: {
    index: new Date().getTime() + Math.random(),
    message,
    variant: 'success',
    ...options,
  },
});

export const removeNotification = index => ({
  type: utilsTypes.REMOVE_NOTIFICATION,
  index,
});

export const addToHistory = (url, params = {}) => ({
  type: utilsTypes.ADD_TO_HISTORY,
  url,
  params,
});



// WEBPACK FOOTER //
// ./src/utils/utilsActions.js